//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "returnVisit-popup-view",
    props: {
        value: {
            type: Boolean,
            required: true
        },
        organizationId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            returnVisitDto: {
                id: 0,
                workOrderId: 0,
                name: '',
                mobile: '',
                content: '',
                score: null
            },
            saving: false,
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel', false)
        },
        onSave() {
            const vm = this;
            if (this.returnVisitDto.score === undefined || !this.returnVisitDto.score) {
                this.$toast('请选择客户满意度！')
                return
            }

            vm.returnVisitDto.workOrderId = vm.workOrderInfo.id;
            // console.log(vm.returnVisitDto);
            // return;
            let data = JSON.parse(JSON.stringify(vm.returnVisitDto));
            data.score = parseInt(data.score);
            vm.saving = true;
            abp.ajax.post('/api/services/app/WorkOrder/MSaveReturnVisit', data).then(() => {
                vm.cancel();
                vm.$emit('save')
            }).finally(() => {
                vm.saving = false;
            });
        },
        setDto(d) {
            this.returnVisitDto = {
                id: 0,
                score: null
            }
            this.returnVisitDto.workOrderId = d.workOrderId;
            this.returnVisitDto.name = d.name;
            this.returnVisitDto.mobile = d.mobile;
        },
    },
    created() {

    }
}
